import useSWR from 'swr';
import { EngineService } from '@/services/engine/engine-service';
import type { FullUser } from '@/types/user';
import { CACHE_KEYS } from '@/constants/cache-keys';

export function useAuthUser() {
    const { data, isLoading, error, mutate } = useSWR<FullUser | null>(
        CACHE_KEYS.AUTH_USER,
        async () => {
            try {
                return await EngineService.checkAuth();
            } catch (err) {
                if (err && typeof err === 'object' && 'response' in err) {
                    const axiosError = err as {
                        response?: { status?: number };
                    };
                    if (
                        axiosError.response?.status === 401 ||
                        axiosError.response?.status === 403
                    ) {
                        return null;
                    }
                }
                throw err;
            }
        },
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    );

    return {
        user: data ?? null,
        isLoading,
        error,
        mutate,
    };
}
